import React, { Component } from 'react'
import gsap from 'gsap'

import './Clipper.css'

class Clipper extends Component {

    constructor(props) {
        super(props)

        this.animate = this.animate.bind(this)
    }

    componentDidMount() {
        this.animate()
    }

    animate() {
        // Using clipPath with inset() - GSAP 3 compatible
        // inset(top right bottom left)
        gsap.fromTo(this.el, {
            clipPath: "inset(50% 37.5% 50% 50%)"  // Equivalent to rect(400px 300px 300px 400px) on 800x600
        }, {
            duration: 1,
            clipPath: "inset(0% 0% 0% 0%)",  // Equivalent to rect(0 800px 600px 0) - fully visible
            ease: "power2.out"
        })
    }


    render() {

        const { clipperStyle } = this.props

        return (

            <div className="clipperWrapper">
                <div className="clipper" ref={el => { this.el = el }} style={clipperStyle}>
                    {this.props.children}
                </div>
            </div>

        );
    }
}

export default Clipper;
